import React from 'react';
import SubmitClaimWizard from './SubmitClaimWizard';

const JoinLoss = () => {
  return <SubmitClaimWizard initialStep={4} />;
};

export default JoinLoss;